export { default as EmailTemplatesRouteService } from './EmailTemplatesRouteService';
export { default as EmailTemplatesService } from './EmailTemplatesService';
